














import Vue from 'vue';
import { mapState as mapRootState } from 'vuex';
export default Vue.extend({
    props: {
        noBody: {
            type: Boolean,
            default: false,
        },
        noHeader: {
            type: Boolean,
            default: false,
        },
        noFooter: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapRootState(['portalBranding']),
    },

    mounted() {
        const cardHeader = document.querySelector<HTMLDivElement>('.card .card-header');

        if (cardHeader && this.portalBranding) {
            cardHeader.style.backgroundColor = `#${this.portalBranding.portalPrimaryColor}`;
        }
    },
});
